import axios from "axios";
import { atom, getDefaultStore } from "jotai";

// Set when an authed request is rejected with the forced-2FA marker; drives the
// blocking ForceTwoFactor gate. The current user's `next_step` is the primary
// trigger — this atom is the fallback for any request blocked by the backend's
// setup-only 403 allowlist (staff forced to enrol, e.g. @techpartners.asia).
export const forced2faAtom = atom(false);

let registered = false;

// Registers a single global axios response interceptor. Idempotent so it is safe
// to call from app bootstrap.
export const registerForced2faInterceptor = () => {
  if (registered) return;
  registered = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const data = error?.response?.data;
      const isForced2fa =
        status === 403 &&
        (data?.next_step === "two_factor_setup" ||
          data?.error === "two_factor_setup_required" ||
          data?.code === "two_factor_setup_required");

      if (isForced2fa) {
        getDefaultStore().set(forced2faAtom, true);
      }

      return Promise.reject(error);
    },
  );
};
